import { render } from "./Demo.vue?vue&type=template&id=18611d10&scoped=true&ts=true"
import script from "./Demo.vue?vue&type=script&lang=ts"
export * from "./Demo.vue?vue&type=script&lang=ts"

import "./Demo.vue?vue&type=style&index=0&id=18611d10&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18611d10"]])

export default __exports__